import { Button, Checkbox, Col, DatePicker, Form, Input, Modal, notification, Row } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { plantApi } from 'api/plantApi';
import { useAppSelector } from 'app/hooks';
import { selectIsDisable } from 'features/Login/authSlice';
import { maintenance, paramOption } from 'models';
import moment from 'moment';
import * as React from 'react';
import { GrAddCircle } from 'react-icons/gr';
import { selectPlantItemSidebar } from '../Sidebar/sidebarSlice';
import style from './Modal.module.scss';
export interface AddEditFormMaintenanceProps {
  isEvent: boolean | null;
  maintenanceInfo: maintenance | null;
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;
  setIsShowCurrent: (value: any) => void;
  setMaintenanceList: (value: maintenance[]) => void;
  today: moment.Moment;
}

export default function AddEditFormMaintenance({
  isEvent,
  maintenanceInfo,
  isModalVisible,
  setIsModalVisible,
  setIsShowCurrent,
  setMaintenanceList,
  today,
}: AddEditFormMaintenanceProps) {
  const [form] = Form.useForm();
  const plantItemSelected = useAppSelector(selectPlantItemSidebar);
  const [valueCheckBox, setValueCheckBox] = React.useState<CheckboxValueType[]>([]);
  const [valueInput, setValueInput] = React.useState<string>('');
  const isDisable = useAppSelector(selectIsDisable);

  const [options, setOptions] = React.useState<paramOption[]>([
    { label: 'Đo dòng, áp của chuỗi pin', value: 'Đo dòng, áp của chuỗi pin' },
    {
      label: 'Quét nhiệt tủ DC, AC, và đầu MC4',
      value: 'Quét nhiệt tủ DC, AC, và đầu MC4',
    },
    {
      label: 'Kiểm tra nhiệt độ, tình hình tấm pin bằng Flycam',
      value: 'Kiểm tra nhiệt độ, tình hình tấm pin bằng Flycam',
    },
    { label: 'Đo điện trở tiếp địa', value: 'Đo điện trở tiếp địa' },
    {
      label: 'Đo điện trở cách điện Ac và chuỗi oin',
      value: 'Đo điện trở cách điện Ac và chuỗi oin',
    },
    { label: 'Đo I-V', value: 'Đo I-V' },
    {
      label:
        'Lau tấm pin, kiểm tra dầu hệ thông, quét bụi bên trong sửa chữa hỏng hóc nhỏ của hệ thống khung giàn đỡ tấm pin',
      value:
        'Lau tấm pin, kiểm tra dầu hệ thông, quét bụi bên trong sửa chữa hỏng hóc nhỏ của hệ thống khung giàn đỡ tấm pin',
    },
  ]);

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const convertStringToArray = (string: string) => {
    let newListOne = string.split(',');
    let newListTwo: string[] = [];
    newListOne.map((item) => {
      return (newListTwo = [...newListTwo, item.trim()]);
    });
    return newListTwo;
  };

  const handleOk = async (values: any) => {
    try {
      if (!isEvent) {
        const editMaintenance = {
          jobs_completed: valueCheckBox,
          result_note: values.result_note,
        };
        await plantApi.updateMaintenance({
          type: 'maintenance-plan',
          id: plantItemSelected,
          editMaintenance: editMaintenance,
        });
        const responseTwo: maintenance[] = await plantApi.fetchMaintenanceList({
          type: 'maintenance-history',
          id: plantItemSelected,
          start_time: moment(moment(today).format('YYYY')).valueOf(),
          end_time: moment(moment(today).add('y', 1).format('YYYY')).valueOf(),
        });
        setMaintenanceList(responseTwo);
        setIsShowCurrent(null);
        openNotificationWithIcon('success', 'Update maintenance successfully');
      } else {
        const newMaintenance = {
          assigned_to: convertStringToArray(values.assigned_to),
          description: values.description === undefined ? null : values.description,
          jobs: valueCheckBox,
          time: moment(values.time._d).valueOf(),
          title: values.title,
          result_note: values.result_note,
        };
        const response: maintenance = await plantApi.addMaintenance({
          type: 'maintenance-plan',
          id: plantItemSelected,
          newMaintenance: newMaintenance,
        });
        setIsShowCurrent({
          title: response.title,
          time: moment(response.time),
          jobs: response.jobs,
          description: response.description,
          result_note: response.result_note,
          assigned_to: response.assigned_to.toString(),
        });
        openNotificationWithIcon('success', 'Create maintenance successfully');
      }
    } catch (error) {
      openNotificationWithIcon('error', 'please check the data again!');
    }
    setIsModalVisible(false);
    form.resetFields();
  };

  function onChangeCheckBox(checkedValues: CheckboxValueType[]) {
    setValueCheckBox(checkedValues);
  }

  const setOptionListTwo = (array: string[]) => {
    let newArray: paramOption[] = [];
    array.map((item: string) => {
      let newItem = {
        label: item,
        value: item,
      };
      return (newArray = [...newArray, newItem]);
    });
    return newArray;
  };

  const setOptionList = () => {
    if (valueInput !== '') {
      let newItem = {
        label: valueInput,
        value: valueInput,
      };
      setOptions([newItem, ...options]);
      setValueInput('');
    }
  };

  return (
    <Modal
      visible={isModalVisible}
      title={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '18px',
            fontWeight: 'bold',
          }}
        >
          {maintenanceInfo ? 'Thông tin bảo trì' : 'Đặt lịch bảo trì'}
        </div>
      }
      footer={
        <div className={style.footer_modal}>
          <div onClick={handleCancel} className={style.btn_cancel}>
            Cancel
          </div>
          {isEvent !== null && (
            <Button disabled={isDisable} onClick={() => form.submit()} className={style.btn_submit}>
              Submit
            </Button>
          )}
        </div>
      }
      width={720}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        initialValues={maintenanceInfo ? maintenanceInfo : {}}
        onFinish={(values) => handleOk(values)}
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 20,
        }}
      >
        <Form.Item name="title" label="Tiêu đề :">
          <Input
            className="input-maintenance"
            placeholder="Please enter Code"
            disabled={!isEvent ? true : false}
          />
        </Form.Item>
        <Form.Item name="time" label="Chọn thời gian : ">
          <DatePicker
            style={{
              width: '210px',
            }}
            disabled={!isEvent ? true : false}
          />
        </Form.Item>
        <Form.Item name="jobs" label="Công việc :">
          <div
            className=""
            style={{
              height: '200px',
              overflowY: 'auto',
              overflowX: 'clip',
            }}
          >
            <Checkbox.Group
              style={{ width: '100%', paddingTop: '8px', paddingLeft: '60px' }}
              onChange={onChangeCheckBox}
            >
              <Row>
                {maintenanceInfo
                  ? setOptionListTwo(maintenanceInfo.jobs).map((x) => (
                      <Col span={24}>
                        <Checkbox value={x.value} disabled={isEvent === null ? true : false}>
                          {x.label}
                        </Checkbox>
                      </Col>
                    ))
                  : options.map((x) => (
                      <Col span={24}>
                        <Checkbox value={x.value}>{x.label}</Checkbox>
                      </Col>
                    ))}
              </Row>
            </Checkbox.Group>
          </div>
        </Form.Item>
        <Row
          gutter={16}
          style={{
            marginBottom: '10px',
          }}
        >
          <Col
            span={6}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end ',
            }}
          >
            <GrAddCircle
              style={{
                fontSize: '20px',
                cursor: 'pointer',
              }}
              onClick={() => setOptionList()}
            />
          </Col>
          <Col span={18}>
            <Input
              id="myInput"
              className="input-maintenance"
              disabled={!isEvent ? true : false}
              style={{
                marginLeft: '5px',
                width: '98%',
              }}
              value={valueInput === '' ? '' : valueInput}
              onChange={(e) => {
                setValueInput(e.target.value);
              }}
            />
          </Col>
        </Row>
        <Form.Item name="description" label="Mô tả :">
          <Input.TextArea className="input-maintenance" disabled={!isEvent ? true : false} />
        </Form.Item>
        <Form.Item name="result_note" label="Ghi chú:">
          <Input.TextArea
            className="input-maintenance"
            disabled={isEvent === null ? true : false}
          />
        </Form.Item>
        <Form.Item name="assigned_to" label="Người phụ trách">
          <Input
            className="input-maintenance"
            placeholder="Please enter Code"
            disabled={!isEvent ? true : false}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
